export default {
  gutteringSm: 20,
  gutteringLg: 40,
  panelMaxWidth: 440,
  landingSectionMaxWidth: 530,
};
